<img class="img-fluid" [src]="data.src" *ngIf="!value" [style.height]="data.height"/>
<img class="img-fluid" [src]="data.activeSrc" *ngIf="value" [style.height]="data.height"/>